import React from 'react';
import '../App.css';
import './Projects.css';

function Projects() {
  return (
    <>
      <div className="projects-container">
        <h1 className="projects-title">My Projects</h1>
        
        <div className="projects-grid">
          <div className="project-card">
            <div className="project-card-inner">
                             <div className="project-card-front">
                 <h3><strong>Honorably</strong></h3>
               </div>
                              <div className="project-card-back">
                  <p>
                    GPT-based website to promote honor and integrity in academic settings with privacy and moderation features<br/>
                    <a href="https://www.honorably.art" target="_blank" rel="noopener noreferrer">www.honorably.art</a> - Honorably, because you shouldn't cheat on everything.
                  </p>
                </div>
            </div>
          </div>

          <div className="project-card">
            <div className="project-card-inner">
                             <div className="project-card-front">
                 <h3><strong>ClearTrack</strong></h3>
               </div>
              <div className="project-card-back">
                <p>
                  A Python Git hook that enables users to show work across workplaces.
                  It works by using a central log to which users can push using the push-tracked command. 
                  This command does not view or transmit any data, only that the user contributed.
                </p>
              </div>
            </div>
          </div>

          <div className="project-card">
            <div className="project-card-inner">
                             <div className="project-card-front">
                 <h3><strong>Personal Website</strong></h3>
               </div>
              <div className="project-card-back">
                <p>
                  This website! Developed and polished using React.js and CSS with backend server for emails.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default Projects;
